import React from 'react'

const Thead = ({children}) => {
  return (
    <thead>
      {children}
    </thead>
  )
}

export default Thead
